window.utils = {
    formatNumber(number) {
        return parseFloat(number).toString().replace('.', ',');
    },

    formatSek(amount) {
        return this.formatNumber(amount) + ' kr';
    },

    handleNoScrollToggle(toggleValue) {
        if (! window.noScrollComponentsOpenCount) {
            window.window.noScrollComponentsOpenCount = 0;
        }

        window.noScrollComponentsOpenCount += toggleValue ? 1 : -1;

        document.querySelectorAll('[data-no-scroll-hook]').forEach((element) => {
            element.classList.toggle('no-scroll', !! window.noScrollComponentsOpenCount);
        });
    },
};
